export enum MarkName {
  Strong = 'strong',
  Em = 'em',
  Strikethrough = 'strikethrough',
  Underline = 'underline',
  Link = 'link',
}
